import NodeEvents from 'events';
import * as Inovx from '@shared';
import HomeConstants from '../constants/HomeConstants';

const EventEmitter = NodeEvents.EventEmitter;
const PermissionService = Inovx.Shared.Permission.PermissionService;
const CHANGE_EVENT = 'Home.change';

const FACILITY_USE_PERMISSION = 'Facility.Use';
const MANAGE_FACILITY_PERMISSION = 'Facility.Manage';
const MANAGE_KB_PERMISSION = 'Facility.ManageKB';

let _sidebarOpen = false;
let _selectedMenu = '';
let _loading = true;

const HomeStore = Object.assign({}, EventEmitter.prototype, {
    getSidebarOpen(): boolean {
        return _sidebarOpen;
    },
    getSelectedMenu(): string {
        return _selectedMenu;
    },
    getPageLoading(): boolean {
        return _loading;
    },
    hasFacilityExplorePermission(): boolean {
        return (
            PermissionService.checkPermission(FACILITY_USE_PERMISSION) ||
            PermissionService.checkPermission(MANAGE_KB_PERMISSION) ||
            PermissionService.checkPermission(MANAGE_FACILITY_PERMISSION)
        );
    },
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback: () => void) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback: () => void) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

Inovx.Shared.Flux.AppDispatcher.register((payload: any) => {
    switch (payload.actionType) {
        case HomeConstants.HOME_OPEN_SIDEBAR:
            _sidebarOpen = true;
            break;
        case HomeConstants.HOME_CLOSE_SIDEBAR:
            _sidebarOpen = false;
            break;
        case HomeConstants.HOME_SELECTED_MENU:
            _selectedMenu = payload.menu ?? '';
            break;
        case HomeConstants.HOME_PAGE_LOADING:
            _loading = payload.isLoading;
            break;
        default:
            return true;
    }
    HomeStore.emitChange();
    return true;
});

export default HomeStore;
